import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { getUserRole } from "../../Utility/service";
import { ThemeContext } from "../../contexts/themeConfig";

const NavLinks = ({ svg, link, text, setChatLog }) => {
  const { theme } = useContext(ThemeContext);
  const userRole = getUserRole()

  const handleClick = async (text) => {

    if (text === "Clear Conversations") {
      setChatLog([]);
    }
    if (text === "Log out") {
      try {;
        // let logOut = await signOut(auth);
        // console.log("logOut", logOut);
        // dispatch({ type: "LOGOUT" });
      } catch (error) {
        console.error("Error occurred during sign out:", error);
      }
    }
  };

  // Generate ID for the link
  const roleSuffix = userRole === "superadmin" ? "sa" : userRole === "admin" ? "ad" : "user";
  const linkId = `${text.toLowerCase().replace(/\s/g, "-")}-${roleSuffix}-navlink`;

  return (
    <Link
      id={linkId}
      to={link}
      target={link ? "_self" : "_blank"}
      rel="noreferrer"
      style={{
        textDecoration: "none",
        color: theme === "light" ? "#000" : "#fff",
      }}
      onClick={() => handleClick(text)}
    >
      <div className="navPrompt">
        {svg}
        <p>{text}</p>
      </div>
    </Link>
  );
};

export default NavLinks;
